import { SftpConnectionsPanel } from '@today/ui-domain'
import { useSftpConnectors } from '@/hooks/useSftpConnectors'

/**
 * The "SFTP connections" panel of the File exchange section (TO-393 REQ-014):
 * Super-Admin only, so it is mounted on the platform plane only.
 */
export function SftpConnectionsSection({ tenantId }: { tenantId: string }) {
	const sftp = useSftpConnectors(tenantId, true)
	if (sftp.loadFailed) {
		return (
			<p role="alert" className="text-sm text-ds-danger">
				Could not load the SFTP connections.
			</p>
		)
	}
	return (
		<SftpConnectionsPanel
			connectors={sftp.connectors}
			adding={sftp.adding}
			busy={sftp.busy}
			addErrors={sftp.addErrors}
			addError={sftp.addError}
			connectorErrors={sftp.cardErrors}
			onAdd={sftp.add}
			onAddOpenChange={sftp.setAdding}
			onTest={sftp.test}
			onTrust={sftp.trust}
			onDelete={sftp.remove}
			onCopy={(text) => void navigator.clipboard?.writeText(text)}
		/>
	)
}
